export enum OpportunityMode {
  None = 'None',
  Assigned = 'Assigned',
  DiscoveryPhase = 'DiscoveryPhase',
  TroubleShooting = 'TroubleShooting',
  Other = 'Other',
}

export enum OpportunityModeIndex {
  None = 0,
  Assigned = 1,
  DiscoveryPhase = 2,
  TroubleShooting = 3,
  Other = 4,
}

export const OpportunityModeIndexMapper: { [key: number]: OpportunityMode } = {
  [OpportunityModeIndex.None]: OpportunityMode.None,
  [OpportunityModeIndex.Assigned]: OpportunityMode.Assigned,
  [OpportunityModeIndex.DiscoveryPhase]: OpportunityMode.DiscoveryPhase,
  [OpportunityModeIndex.TroubleShooting]: OpportunityMode.TroubleShooting,
  [OpportunityModeIndex.Other]: OpportunityMode.Other,
};
